window.addEventListener('DOMContentLoaded', function() {
    var e = $(".content-wrapper"),
        r = 100;
        
    $('.tabs-wrapper .tabs-wrapper').css('min-height', r);

    $(".hero-info__btn img").on('click', function () {
        $(".hero-image").css({
            transform: "translateX(100%)"
        }), $(".hero").css({
            transform: "translateX(100%)"
        }), $(".video").css({
            transform: "none",
            opacity: 1,
            visibility: "visible"
        })
    });

    $(".tabs-wrapper .tabs .tab-link").on('click', function() {
        if($(this).data('target')) {
            $(".tabs-wrapper .tabs .tab-link").removeClass("active");
            $(this).addClass("active");

            var target = $(this).data('target');
            var tab_height = r;

            if (!$(".tabs-wrapper .tabs").hasClass("tabs-sticky")) {
                tab_height = $('.tabs-wrapper').height();
            } 

            $(".tab-section").hide();
            $("#"+ target).fadeIn();
            $("html, body").animate({
                scrollTop: ($("#"+ target).offset().top - (tab_height + 50))
            }, 1e3);
        }

    });


    function stickyTabs() {
        if ($(".pos").offset().top - 0 <= $(this).scrollTop()) {
           // console.log('Add sticky');
            $(".tabs-wrapper .tabs").addClass("tabs-sticky");
            $(".event-sponsorship").addClass("margin-sticky");
            $(".project-sponsorship").addClass("margin-sticky");

        };
        if ($(".pos").offset().top - 0 > $(this).scrollTop()) {
            //console.log('Remove sticky');
            $(".tabs-wrapper .tabs").removeClass("tabs-sticky")
            $(".event-sponsorship").removeClass("margin-sticky");
            $(".project-sponsorship").removeClass("margin-sticky");
        };
    };

    stickyTabs();


    function a() {
        $(window).width() <= 768 && (e.css({
            paddingTop: 0
        }), $(".tabs-wrapper .tabs").removeClass("tabs-sticky"))
    }

    a();
    
    $(window).on("scroll", function () {
         a(), stickyTabs()
    });
            
    $(window).resize(function () {
        a(), stickyTabs()
    }); 

    $(".section-in__link a").click(function () {
        return $("html, body").animate({
            scrollTop: $($.attr(this, "href")).offset().top
        }, 1e3), !1
    });
    
    var swiperEvents = new Swiper('.swiper-events .swiper-container', {
        loop: true,
        width: 410,
        spaceBetween: 40,
        calculateHeight: true,
        loopedSlides: 12,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        580: {
            width: 280,
            spaceBetween: 10
        }
        }
    });
    

  
      $("#engin-form-1").on("click", function(e) {
          e.preventDefault();
          console.log("engineering form");

          var src = '#hubspot-contact-form--engineering';

          $.fancybox.open({
              src  : src,
              type : 'inline',
              width : '100%',
              height : 'auto'
          });
    	});

        $("#engin-form-2").on("click", function(e) {
            e.preventDefault();
            console.log("engineering form");
  
            var src = '#hubspot-contact-form--engineering';
  
            $.fancybox.open({
                src  : src,
                type : 'inline',
                width : '100%',
                height : 'auto'
            });
          });
  
  
        $("#hubspot-purchasing-form").on("click", function(e) {
          e.preventDefault();
          console.log("purchasing  form");

          var src = '#hubspot-contact-form--purchasing';

          $.fancybox.open({
              src  : src,
              type : 'inline',
              width : '100%',
              height : 'auto'
          });
    	});

        $("#hubspot-purchasing-form-2").on("click", function(e) {
            e.preventDefault();
            console.log("purchasing  form");
  
            var src = '#hubspot-contact-form--purchasing';
  
            $.fancybox.open({
                src  : src,
                type : 'inline',
                width : '100%',
                height : 'auto'
            });
          });
  
        $("#hubspot-purchasing-form-b").on("click", function(e) {
            e.preventDefault();
            console.log("purchasing  form");

            var src = '#hubspot-contact-form--purchasing';

            $.fancybox.open({
              src  : src,
              type : 'inline',
              width : '100%',
              height : 'auto'
            });
          });
  
          $("#engin-form-0").on("click", function(e) {
              e.preventDefault();
              console.log("engineering form");

              var src = '#hubspot-contact-form--engineering';

              $.fancybox.open({
                  src  : src,
                  type : 'inline',
                  width : '100%',
                  height : 'auto'
              });
  			});


});  